import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../common/html/button'
import { changeReCountNotifications } from '../../layout/store/slice'
import { FILTER_LIST, SCREEN_TYPE } from '../constants'
import {
  changeIsScroll,
  changePage,
  changeTab,
  maskAllAsRead,
  selectTab,
} from '../store/slice'
import { postMarkAllAsRead } from '../store/thunk'
import TextLink from './TextLink'

const Filter = ({ params, screenType }) => {
  const dispatch = useDispatch()

  const filterActiveKey = useSelector(selectTab)

  const handleFilter = (activeKey) => {
    dispatch(changeIsScroll(false))
    dispatch(changePage({ screenType, newPage: 1 }))
    dispatch(changeTab(activeKey))
  }

  const markAllRead = () => {
    dispatch(postMarkAllAsRead(params))
      .unwrap()
      .then(() => {
        dispatch(changeReCountNotifications())
        dispatch(maskAllAsRead({ screenType }))
      })
      .catch(() => {})
  }

  const getButtonStyle = (isActive) => {
    return {
      color: isActive ? '#FFFFFF' : '#191D25',
      backgroundColor: isActive ? '#2C73E8' : '#F3F3F3',
      border: 'none',
      padding: '2px 8px',
      textTransform: 'capitalize',
    }
  }

  return (
    <div
      className={[
        'dFlex justifyContentBetween alignItemsCenter',
        screenType !== SCREEN_TYPE.VIEW_ALL && 'my1',
      ].join(' ')}
    >
      <div style={{ borderRadius: '4px', overflow: 'hidden' }}>
        {FILTER_LIST.map((item) => {
          return (
            <Button
              isI18n
              key={item.label}
              label={item.label}
              className="cursorPointer"
              action={() => handleFilter(item.activeKey)}
              style={getButtonStyle(filterActiveKey === item.activeKey)}
            />
          )
        })}
      </div>
      <TextLink
        onClick={markAllRead}
        value={'systemNotifications.MARK_ALL_AS_READ'}
      />
    </div>
  )
}

Filter.propTypes = {
  isViewAll: PropTypes.bool,
  params: PropTypes.object.isRequired,
}

Filter.defaultProps = {
  isViewAll: true,
}

export default Filter
